import React, { useState, useRef } from 'react';
import ImageIcon from '@material-ui/icons/Image';
import './style.css';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { Link } from 'react-router-dom';
import { OrderComponent } from '../../../Components';
import Tshirt from '../../../Assets/Photos/tshirt.png';
import { ProductTypePopup } from '../..';
import PrintMockup from '../../Popups/PrintMockup/PrintMockup';
const Index = () => {
    const [popup, setPopup] = useState(false);
    return (
        <>
            <ProductTypePopup
                state={popup}
                setStateFalse={() => {
                    setPopup(false);
                }}
            />
            <div className="newOrder">
                <div className="newOrder_head">
                    <div className="newOrder_head_left">
                        <h2>New Order</h2>
                        <p>Add a product to start creating your order</p>
                    </div>
                    <button
                        onClick={() => {
                            setPopup(true);
                        }}
                        className="btn-orange "
                    >
                        <ImageIcon className="btn-icon" />
                        <p>Add Design</p>
                    </button>
                </div>
                <Component heading="Men’s Clothing" />
                <Component heading="Women’s Clothing" />
            </div>
        </>
    );
};

const Component = ({ heading }) => {
    const scrollRef = useRef();

    const leftScroll = async () => {
        const speed = 400 / 1000;
        for (let i = 0; i < 100; i++) {
            scrollRef.current.scrollLeft = scrollRef.current.scrollLeft - 4;
            await new Promise((resolve) => setTimeout(resolve, speed));
        }
    };
    const rightScroll = async () => {
        const speed = 400 / 1000;
        for (let i = 0; i < 100; i++) {
            scrollRef.current.scrollLeft = scrollRef.current.scrollLeft + 4;
            await new Promise((resolve) => setTimeout(resolve, speed));
        }
    };
    return (
        <div className="newOrder_collection">
            <div className="newOrder_collection_head">
                <h4>{heading}</h4>
                <div className="newOrder_collection_head_right">
                    <ChevronLeftIcon
                        onClick={leftScroll}
                        className={`newOrder_collection_head_right_icon ${scrollRef.current ? (scrollRef.current.scrollLeft === 0 ? 'disabled' : '') : ''
                            }`}
                    />
                    <ChevronRightIcon
                        onClick={rightScroll}
                        className={`newOrder_collection_head_right_icon ${scrollRef.current
                            ? scrollRef.current.scrollLeft === scrollRef.current.scrollHeight
                                ? 'disabled'
                                : ''
                            : ''
                            }`}
                    />
                    <Link className="orange-link" to={`/main/viewAll/${encodeURIComponent(heading)}`}>
                        See All
                    </Link>
                </div>
            </div>
            <div ref={scrollRef} className="newOrder_collection_container">
                <OrderComponent image={Tshirt} text="Lorem Ipsum Tshirt" />
                <OrderComponent image={Tshirt} text="Lorem Ipsum Tshirt" />
                <OrderComponent image={Tshirt} text="Lorem Ipsum Tshirt" />
                <OrderComponent image={Tshirt} text="Lorem Ipsum Tshirt" />
                <OrderComponent image={Tshirt} text="Lorem Ipsum Tshirt" />
            </div>
        </div>
    );
};

export default Index;
